import { ConfigFilter } from "../types";

export const getConfigFilter = (filterName: string, configFilters: ConfigFilter[]): ConfigFilter =>
  configFilters?.find(item => item.name === filterName);
